import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
require('highcharts/modules/heatmap')(Highcharts)
// import HC_more from 'highcharts/highcharts-more.src'
// HC_more(Highcharts)

export class HighChart extends Component {
  static propTypes = {
    componentes: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    
    const { options } = this.props;
    return (
      
      <div className="componentes-high-chart">
        <HighchartsReact
          highcharts={Highcharts}
          constructorType={'chart'}
          options={options}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    componentes: state.componentes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HighChart);



// WEBPACK FOOTER //
// ./src/features/componentes/HighChart.js